"use client"

import { Col, Row, Skeleton } from 'antd'
import ProductItemSkeleton from '../../Category/Products/ProductItem.skeleton'
import { TypeStoreDetail } from '@/lib/redux/features/store/type'

type CategoryProductsItemSkeletonProps = {
  category?: any,
  countProduct?: number,
  customGridProducts?: number,
  store: TypeStoreDetail,
  index?: any
}

const CategoryProductsItemSkeleton = (props: CategoryProductsItemSkeletonProps) => {
  return (
    <Row
      justify='center'
      style={{
        backgroundColor: props.index === undefined ? undefined : (props.index || 0) % 2 === 0
          ? 'rgba(24, 21, 21, 0.1)'
          : 'rgba(213, 214, 208, 0.1)'
      }}
    >
      <Col span={24} className='page__section'>
        {!!props.category && (
          <Row justify="center">
            <Col flex={"15rem"}>
              <Skeleton styles={{ title: { height: `${(props.store.category_section.name.size / 10) + 0.2}rem` } }} paragraph={false} />
            </Col>
          </Row>
        )}
        <Row className='category__section--content' style={{ marginBottom: '2rem' }} gutter={[15, 15]}>
          {Array(props.countProduct || 1).fill(null)
            .map((_, index) => {
              return (
                <ProductItemSkeleton store={props.store} customGridProduct={props.customGridProducts || (!!props.category ? props.store.products_per_category_section || 5 : undefined)} key={index} />
              )
            })}
        </Row>
        {!!props.category && (
          <Row justify="center" style={{ marginBottom: "2rem" }}>
            <Col>
              <Skeleton.Button active style={{ width: "20rem" }} />
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  )
}

export default CategoryProductsItemSkeleton